module.exports = __webpack_public_path__ + "static/media/money.9f12e006.svg";